import { tokenStorage } from '../utils/tokenStorage';
import { logoutUser } from '../store/slices';
import { broadcastLogout } from '../utils/tokenBroadcast';
import { getUserEndpoint } from '../utils/apiEndpoint';

const userEndpoint = getUserEndpoint();

/**
 * Logout: optionally notify server with Bearer access token, then clear storage and redirect.
 *
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} navigate - React Router navigate function (optional)
 * @returns {Promise<void>}
 */
export const handleLogout = async (dispatch, navigate = null) => {
  const accessToken = tokenStorage.getAccessToken();

  try {
    if (accessToken) {
      try {
        await fetch(`${userEndpoint}/auth/logout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({}),
        });
      } catch (error) {
        console.error('Logout API error:', error);
      }
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    tokenStorage.clearTokens();
    dispatch(logoutUser());
    broadcastLogout();

    if (navigate) {
      navigate('/login');
    } else if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
};
